import { render, staticRenderFns } from "./JobCard.vue?vue&type=template&id=27d39c38&scoped=true"
import script from "./JobCard.vue?vue&type=script&lang=js"
export * from "./JobCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d39c38",
  null
  
)

export default component.exports